import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer-banner',
    templateUrl: './footer-banner.component.html',
    styleUrls: ['./footer-banner.component.scss'],
    standalone: false
})
export class FooterBannerComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
